import React from 'react';
//ICONO CON TOOLTIP
import IconInfo from '../../../Comun/IconInfo/IconInfo';

//ICONOS
import {
    AccountBalanceOutlined, RoomOutlined, SupervisorAccount, People,
    AttachFile, Person, AccountBox, Error, Email, Phone, Payment, QueryBuilder
} from '@material-ui/icons';

const PrimerPaso = (props) => {
    const { responsables, establecimientos } = props;

    return (
        <>
            <h4 className="mt-2">Responsable{responsables.length > 0 && "s"}:</h4>
            <div className="pl-3 p-1">
                {responsables.map((item) =>
                    <div key={item.dni}>
                        <div>
                            <b className="text-success"><IconInfo mensaje="Responsable" icono={Person} /> </b><b>{item.apellido}, {item.nombre} ({item.vinculo}).</b> {item.principal && <b className="text-success"><IconInfo mensaje="Responsable Principal" icono={AccountBox} /></b>}
                        </div>
                        {/* <div className="pl-5">
                            <div><b className="text-success"><IconInfo mensaje="Nro. Documento" icono={Payment} /> </b>{item.dni}.</div>
                            <div><b className="text-success"><IconInfo mensaje="Teléfono" icono={Phone} /> </b>{item.telefono}.</div>
                            <div><b className="text-success"><IconInfo mensaje="Correo" icono={Email} /> </b>{item.email}.</div>
                        </div> */}
                    </div>
                )}
            </div>
            <h4 className="mt-3">Establecimiento{establecimientos.length > 0 && "s"} Seleccionado{establecimientos.length > 0 && "s"}: </h4>
            {establecimientos.map((item, i) =>
                <div key={i} className="pl-3 pb-5" >
                    <h6>{i + 1}. <b className="text-success"><IconInfo mensaje="Establecimiento" icono={AccountBalanceOutlined} /></b> {item.cueAnexo} - {item.nombre}.</h6>
                    <div className="pl-5">
                        <div><b className="text-success"><IconInfo mensaje="Turno" icono={QueryBuilder} /></b> {item.turno}.</div>
                        <div><b className="text-success"><IconInfo mensaje="Dirección" icono={RoomOutlined} /></b> {item.direccion}.</div>
                        {item.mensaje && <div><b className="text-danger"><IconInfo mensaje="Advertencia" icono={Error} /></b> {item.mensaje}</div>}
                    </div>

                    <br />
                    {/*<u className="pt-2">Información Relacionada al Establecimiento</u>*/}
                    {(item.hermano || item.familiar || item.inscAsociada) &&
                        <div className="pl-5">
                            {item.hermano && <div><b className="text-success"><IconInfo mensaje="Familiar Directo Estudiando" icono={People} /></b> Tiene familiar directo <b>estudiando</b> aquí.</div>}
                            {item.familiar && <div><b className="text-success"><IconInfo mensaje="Familiar Directo Trabajando" icono={SupervisorAccount} /></b> Tiene familiar directo <b>trabajando</b> aquí.</div>}
                            {item.inscAsociada && <div><b className="text-success"><IconInfo mensaje="Inscripción Asociada" icono={AttachFile} /></b> Tiene una <b>inscripción asociada</b> aquí.</div>}
                        </div>
                        /*:
                        <div className="p-1"><b className="text-danger"><CancelIcon className="pb-1" /></b>No contiene información relacioanda con este establecimiento.</div>*/
                    }
                </div>
            )}
        </>
    )
}

export default PrimerPaso;